<template>
  <!-- <div class="tw-flex tw-gap-1">
    <div class="tw-text-sm tw-font-medium">Legend:</div>
    <div class="tw-flex tw-items-center tw-gap-2">
      <div
        class="tw-h-4 tw-w-4 tw-rounded tw-border tw-border-gray tw-bg-[#A23AF177]"
      ></div>
      <span class="tw-text-sm">Available</span>
    </div>
    <div class="tw-flex tw-items-center tw-gap-2">
      <div
        class="tw-h-4 tw-w-4 tw-rounded tw-border tw-border-gray tw-bg-yellow"
      ></div>
      <span class="tw-text-sm">If needed</span>
    </div>
    <div class="tw-flex tw-items-center tw-gap-2">
      <div
        class="tw-h-4 tw-w-4 tw-rounded tw-border tw-border-gray tw-bg-[#FAF1F1]"
      ></div>
      <span class="tw-text-sm">Unavailable</span>
    </div>
  </div> -->
  <div class="tw-flex tw-flex-col tw-gap-2">
    <div class="tw-text-sm tw-font-medium">Legend:</div>

    <div class="tw-flex tw-items-center tw-gap-2">
      <div
        class="tw-h-4 tw-w-4 tw-rounded tw-border tw-border-gray"
        :class="showMyAvailability ? 'tw-bg-[#A23AF177]' : 'tw-bg-[#A23AF1]'"
      ></div>
      <span class="tw-text-sm">{{
        showMyAvailability
          ? "My Availability"
          : "Mutual availability from responses so far"
      }}</span>
    </div>

    <!-- <div class="tw-flex tw-items-center tw-gap-2">
      <div class="tw-h-4 tw-w-4 tw-rounded tw-border tw-border-gray tw-bg-[#A23AF177]"></div>
      <span class="tw-text-sm">Available</span>
    </div> -->

    <div class="tw-flex tw-items-center tw-gap-2">
      <div
        class="tw-h-4 tw-w-4 tw-rounded tw-border tw-border-gray tw-bg-[#9E9E9E4D]"
      ></div>
      <span class="tw-text-sm">Unavailable</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ColorLegend",

  props: {
    isOwner: { type: Boolean, default: false },
    isEditMode: { type: Boolean, default: false },
  },

  computed: {
    showMyAvailability() {
      // Show "My Availability" if:
      // 1. User is NOT the owner (other users always see their own availability)
      // 2. User IS the owner AND in edit mode
      return !this.isOwner || (this.isOwner && this.isEditMode)
    },
  },
}
</script>
